<div class="row">
     <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo persona'"
          [valueInput]="option.anagrafica?.tipoPersona?option.anagrafica?.tipoPersona.label:''">
     </div>
     <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Cognome e nome'"
          [valueInput]="(option.anagrafica?.cognome ? option.anagrafica?.cognome : '')+(option.anagrafica?.nome ? (' ' + option.anagrafica?.nome) : '')">
     </div>
     <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Codice fiscale'"
          [valueInput]="option.anagrafica?.codiceFiscale">
     </div>
     <ng-template [ngIf]="isPartiSearch">
          <div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'"[labelInput]="'Sesso'"
               [valueInput]="option.anagrafica?.sesso ? option.anagrafica?.sesso : ''"></div>
          <div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'boolean'" [labelInput]="'Dipendente'"
               [valueInput]="option.anagrafica?.dipendente"></div>
          <div labelTextInput *ngIf="!isControparte" class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Matricola'"
               [valueInput]="option.anagrafica?.matricola"></div>
          <div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Societ&agrave;'"
               [valueInput]="option.anagrafica?.societa"></div>
     </ng-template>
     <ng-template [ngIf]="!isPartiSearch">
          <div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'checklist'"
               [labelInput]="'Ambito di competenza'" [checkListValue]="option.anagrafica?.ambitiCompetenza"></div>
     </ng-template>
</div>
<ng-template [ngIf]="!isPartiSearch">
     <div class="row">
          <!-- <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Codice fiscale'"
               [valueInput]="option.anagrafica?.codiceFiscale ? option.anagrafica?.codiceFiscale:''"></div> -->
          <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'"[labelInput]="'Sesso'"
               [valueInput]="option.anagrafica?.sesso ? option.anagrafica?.sesso : ''"></div>
          <div *ngIf="!isLegale" labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'boolean'"
               [labelInput]="'Convenzione'" [valueInput]="option.anagrafica?.convenzione"></div>
          <div *ngIf="!isLegale" labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'"
               [labelInput]="'Tariffa'" [valueInput]="(option.anagrafica?.tariffa|euro)+' &euro;'"></div>
     </div>
</ng-template>
<div class="row">
     <div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Ragione sociale'"
          [valueInput]="option.anagrafica?.ragioneSociale?option.anagrafica?.ragioneSociale:''"></div>
     <div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Partita Iva'"
          [valueInput]="option.anagrafica?.partitaIva?option.anagrafica?.partitaIva:''"></div>
     <div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'CF Rappresentante Legale'"
          [valueInput]="option.anagrafica?.codiceFiscaleRappresentanteLegale ? option.anagrafica?.codiceFiscaleRappresentanteLegale : ''">
     </div>
     <div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo societ&agrave;'"
          [valueInput]="option.anagrafica?.tipoSocieta?option.anagrafica?.tipoSocieta.label:''"></div>
</div>
<div class="row">
  <div labelTextInput class="col-xs-12 col-sm-12 bloccodati" [typeLabel]="'text'" [labelInput]="'Nominativo originale'"
       [valueInput]="option.anagrafica?.nominativoOriginale ? option.anagrafica?.nominativoOriginale : ''">
  </div>
</div>
<div class="container_fieldset" *ngIf="!hideOtherData">
     <fieldset class="form-group">
          <legend>Nascita<span class="sr-only">ricerca anagrafica</span></legend>
          <div labelTextInput class="col-xs-12 col-sm-2 bloccodati" [typeLabel]="'date'" [labelInput]="'Data'"
               [valueInput]="option.anagrafica?.dataNascita"></div>
          <div labelTextInput class="col-xs-12 col-sm-5 bloccodati" [typeLabel]="'text'" [labelInput]="'Comune'"
               [valueInput]="option.anagrafica?.comuneNascita?option.anagrafica?.comuneNascita.label:''"></div>
          <div labelTextInput class="col-xs-12 col-sm-5 bloccodati" [typeLabel]="'text'" [labelInput]="'Provincia'"
               [valueInput]="option.anagrafica?.provinciaNascita?option.anagrafica?.provinciaNascita.label:''"></div>
     </fieldset>
</div>
<div class="container_fieldset" *ngIf="!hideOtherData">
     <fieldset class="form-group">
          <legend>Residenza <span class="sr-only">ricerca anagrafica</span></legend>
          <div labelTextInput class="col-xs-12 col-sm-8 bloccodati" [typeLabel]="'text'" [labelInput]="'Indirizzo'"
               [valueInput]="option.anagrafica?.indirizzo?option.anagrafica?.indirizzo:''"></div>
          <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Cap'"
               [valueInput]="option.anagrafica?.cap?option.anagrafica?.cap:''"></div>
          <div labelTextInput class="col-xs-12 col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Comune'"
               [valueInput]="option.anagrafica?.comuneResidenza?option.anagrafica?.comuneResidenza.label:''"></div>
          <div labelTextInput class="col-xs-12 col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Provincia'"
               [valueInput]="option.anagrafica?.provinciaResidenza?option.anagrafica?.provinciaResidenza.label:''">
          </div>
     </fieldset>
</div>
<div class="container_fieldset" *ngIf="false"> <!--isPartiSearch (da mettere nell'IF)-->
     <fieldset class="form-group">
          <legend>Dati profilo professionale</legend>
          <!-- <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Figura professionale'"
               [valueInput]="option.anagrafica?.figuraProfessionale?option.anagrafica?.figuraProfessionale.label:''">
          </div> -->
          <div labelTextInput class="col-xs-12 col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Ordine'"
               [valueInput]="option.anagrafica?.ordine ? option.anagrafica?.ordine : ''"></div>
          <!--<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'N&deg; iscrizione albo'"
               [valueInput]="option.anagrafica?.numeroIscrizione ? option.anagrafica?.numeroIscrizione : ''"></div>-->
          <div labelTextInput class="col-xs-12 col-sm-6 bloccodati" [typeLabel]="'date'" [labelInput]="'Data iscrizione Albo'"
               [valueInput]="option.anagrafica?.dataIscrizioneAlbo ? option.anagrafica?.dataIscrizioneAlbo : ''"></div>
          <div class="row">
               <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Codice Cassa'"
                    [valueInput]="option.anagrafica?.codiceMeccanografico ? option.anagrafica?.codiceMeccanografico : ''">
               </div>
               <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'date'" [labelInput]="'Data iscrizione Cassa'"
                    [valueInput]="option.anagrafica?.dataIscrizioneAlbo ? option.anagrafica?.dataIscrizioneCassa : ''"></div>
               <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Status'"
                    [valueInput]="option.anagrafica?.statoAT ? option.anagrafica?.statoAT : ''"></div>
          </div>
          <div class="row" style="padding: 10px;" *ngIf="option.anagrafica?.societa?.length > 0">
               <table class="table-striped table aggiunta_classificazione table_fondo_oneri">
                    <caption class="sr-only">Tabella anagrafiche società</caption>
                    <thead>
                         <th style="width: 20%;">Società</th>
                         <th style="width: 20%;">Carica</th>
                         <th style="width: 10%;">Dal</th>
                         <th style="width: 10%;">Al</th>
                         <th style="width: 15%;">Incarico Rimosso</th>
                         <th style="width: 15%;">% Partecipazione</th>
                         <th style="width: 10%;">Codice ateco</th>
                         <th></th>
                    </thead>
                    <tbody>
                         <!-- <tr *ngFor="let societa of controparte.societa"> -->
                         <tr *ngFor="let societa of option.anagrafica?.societa">
                              <td>{{societa.societa}}</td>
                              <td>{{societa.carica}}</td>
                              <td>{{societa.dataDal | dateformatter: 'DD/MM/YYYY'}}</td>
                              <td>{{societa.dataAl | dateformatter: 'DD/MM/YYYY'}}</td>
                              <td>{{societa.incaricoRimosso}}</td>
                              <td>{{societa.percPartecipazione ? societa.percPartecipazione + '%' : '-'}}</td>
                              <td>{{societa.codiceAteco ? societa.codiceAteco : ''}}</td>
                              <td><a class="dropdown-toggle" style="cursor: pointer; color: #0867b4;"
                                        data-title="dettaglio" (click)="infoSocietaModal.show(societa)">
                                        <span class="glyphicon glyphicon-info-sign"></span>
                                   </a>
                              </td>
                         </tr>
                    </tbody>
               </table>
               <tlf-info-societa-modal #infoSocietaModal></tlf-info-societa-modal>
          </div>
     </fieldset>
</div>
<div class="container_fieldset" *ngIf="!hideOtherData">
     <fieldset class="form-group">
          <legend>Contatti<span class="sr-only">ricerca anagrafica</span></legend>
          <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Telefono'"
               [valueInput]="option.anagrafica?.telefono?option.anagrafica?.telefono:''"></div>
          <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Cellulare'"
               [valueInput]="option.anagrafica?.cellulare?option.anagrafica?.cellulare:''"></div>
          <div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'N&#176; fax'"
               [valueInput]="option.anagrafica?.fax?option.anagrafica?.fax:''"></div>
          <div labelTextInput class="col-xs-12 col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Email'"
               [valueInput]="option.anagrafica?.email?option.anagrafica?.email:''"></div>
          <div labelTextInput class="col-xs-12 col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="'Pec'"
               [valueInput]="option.anagrafica?.pec?option.anagrafica?.pec:''"></div>
     </fieldset>
</div>
<div class="row">
     <div class="col-sm-12 bloccodati">
          <p>
               <label class="col-sm-12">Note</label> <span class="longtext">{{ option.anagrafica?.note ?
                    option.anagrafica?.note : "" }}</span>
          </p>
     </div>
</div>
